import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

import App from './App.vue'
import AppLayout from './layouts/AppLayout.vue'
import LoginPage from './pages/LoginPage.vue'
import DashboardPage from './pages/DashboardPage.vue'
import AcampantesPage from './pages/AcampantesPage.vue'
import CheckInPage from './pages/CheckInPage.vue'
import ConfirmedPage from './pages/ConfirmedPage.vue'
import ScanPage from './pages/ScanPage.vue'
import UsuariosPage from './pages/UsuariosPage.vue'

import { isAuthenticated, getAdmin } from './lib/auth'
import { useAuthStore } from './stores/auth'

const routes = [
  { path: '/login', name: 'Login', component: LoginPage, meta: { public: true } },
  { path: '/scan', name: 'Scan', component: ScanPage, meta: { public: true } },
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', name: 'Dashboard', component: DashboardPage },
      { path: 'acampantes', name: 'Acampantes', component: AcampantesPage },
      { path: 'check-in', name: 'CheckIn', component: CheckInPage },
      { path: 'confirmed', name: 'Confirmed', component: ConfirmedPage },
      { path: 'scanner', name: 'Scanner', component: ScanPage },
      { path: 'usuarios', name: 'Usuarios', component: UsuariosPage, meta: { requiresRoot: true } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!isAuthenticated()) return next('/login')
  if (to.meta.requiresRoot && !getAdmin()?.isRoot) return next('/')
  next()
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(VueToast)

// Restaurar sessão (não bloqueante; se inválida o interceptor 401 limpa)
const authStore = useAuthStore()
authStore.restore().finally(() => {
  app.mount('#app')
})
